import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// By Together (b_395xq4ekla, advertiser 8847865777698056937).
// Lifetime complete-month metrics through Aug 2026.
export const advByTogether: FaireAdvertiserProfileEntity = {
  token: "adv_by_together",
  type: "advertiserProfile",
  archetype: "budget-capped",
  displayName: "By Together",
  brandToken: "b_395xq4ekla",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 27,
  budget: {
    totalBudgetDollars: 15000,
    sharedBudgetDollars: 15000,
    spendingMode: "MODERATE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 1283,
    numReorderConversions: 1389,
    numTotalConversions: 2672,
    totalAdsSalesDollars: 2743626,
    newCustomerAdsSalesDollars: 1524626,
    reorderAdsSalesDollars: 1219000,
    totalAdsSpendDollars: 185689,
    newCustomerAdsSpendDollars: 127768,
    reorderAdsSpendDollars: 57921,
    newCustomerBestEstimateFirstYearRoas: 14.93,
    reorderRoas: 21.05,
    combinedFirstYearRoas: 16.84,
    numNewCustomerAdsOrders: 2738,
    numReorderAdsOrders: 4318,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 7800,
      maxRecommendedBudgetDollars: 9800,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 7700,
      maxRecommendedBudgetDollars: 9700,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_bt_new", "camp_bt_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-24T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
